import React from 'react';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">
              Welcome to Yugalkunj Events
            </h1>
            <p className="text-xl text-gray-600 mb-8">
              Register for sacred events at centers across North America
            </p>
            <button
              onClick={() => navigate('/country')}
              className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:shadow-xl transition-all duration-300 transform hover:scale-105"
            >
              Start Registration
            </button>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section - Matching pleask_yugal_reactproject styling */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Compact Title */}
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-gray-800 mb-2">
              Why Choose Us?
            </h2>
            <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto rounded-full"></div>
          </div>

          {/* Compact Feature Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Sacred Events */}
            <div className="group bg-white rounded-2xl p-6 border-2 border-gray-100 hover:border-blue-300 transition-all duration-300 hover:shadow-lg">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                  <span className="text-2xl">�️</span>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2">
                    Sacred Events
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Participate in traditional Hindu festivals and ceremonies.
                  </p>
                </div>
              </div>
            </div>

            {/* Multiple Centers */}
            <div className="group bg-white rounded-2xl p-6 border-2 border-gray-100 hover:border-purple-300 transition-all duration-300 hover:shadow-lg">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-pink-400 to-purple-500 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                  <span className="text-2xl">🏛️</span>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2">
                    Multiple Centers
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Choose from centers in Atlanta, Milwaukee, Toronto, and more.
                  </p>
                </div>
              </div>
            </div>

            {/* Family Friendly */}
            <div className="group bg-white rounded-2xl p-6 border-2 border-gray-100 hover:border-blue-300 transition-all duration-300 hover:shadow-lg">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-400 to-cyan-500 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                  <span className="text-2xl">👨‍👩‍👧‍👦</span>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2">
                    Family Friendly
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Register your entire family with ease.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">
            How It Works
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-blue-600">1</span>
              </div>
              <h4 className="font-semibold text-gray-800 mb-2">Select Location</h4>
              <p className="text-sm text-gray-600">Choose your country and center</p>
            </div>
            <div className="text-center">
              <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-blue-600">2</span>
              </div>
              <h4 className="font-semibold text-gray-800 mb-2">Pick Event</h4>
              <p className="text-sm text-gray-600">Select event and seva options</p>
            </div>
            <div className="text-center">
              <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-blue-600">3</span>
              </div>
              <h4 className="font-semibold text-gray-800 mb-2">Register</h4>
              <p className="text-sm text-gray-600">Fill in your details and family members</p>
            </div>
            <div className="text-center">
              <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-blue-600">4</span>
              </div>
              <h4 className="font-semibold text-gray-800 mb-2">Complete Payment</h4>
              <p className="text-sm text-gray-600">Secure payment and confirmation</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
